import { render } from "./consultaVenta.vue?vue&type=template&id=2f09a91f&scoped=true"
import script from "./consultaVenta.vue?vue&type=script&lang=js"
export * from "./consultaVenta.vue?vue&type=script&lang=js"

import "./consultaVenta.vue?vue&type=style&index=0&id=2f09a91f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f09a91f"]])

export default __exports__